import { z } from 'zod';
import { anomalyThresholdsSchema } from './visits.js';
// App distribution contracts live in ./app-distribution.ts.
export const updateAnomalyThresholdsRequestSchema = anomalyThresholdsSchema;
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    checks: z.object({
        database: z.enum(['up', 'down']),
        queue: z.enum(['up', 'down', 'disabled']),
        /** Read from stored configuration only – /health never calls Zoho. */
        zoho: z.enum(['configured', 'not_configured', 'degraded', 'unknown']).default('unknown'),
    }),
    version: z.string(),
    time: z.string(),
});
//# sourceMappingURL=settings.js.map